import LanguageManager from "../utils/translations/LanguageManager";

const nl = require("./nl.json");
const fr = require("./fr.json");

export default new LanguageManager({ nl, fr }, "nl");
